class BarkRecentViewers extends HTMLElement {
  connectedCallback() {
    this.refresh = this.refresh.bind(this);
    window.addEventListener('pageshow', this.refresh);
    document.addEventListener('visibilitychange', this.refresh);
    this.refresh();
  }

  disconnectedCallback() {
    clearTimeout(this.expiryTimer);
    window.removeEventListener('pageshow', this.refresh);
    document.removeEventListener('visibilitychange', this.refresh);
  }

  refresh() {
    clearTimeout(this.expiryTimer);
    const count = Number(this.dataset.count);
    const updatedAt = Date.parse(this.dataset.updatedAt);
    const expiresAt = Date.parse(this.dataset.expiresAt);
    const now = Date.now();
    const valid = Number.isSafeInteger(count) && count >= 10
      && Number.isFinite(updatedAt) && Number.isFinite(expiresAt)
      && updatedAt <= now + 60000 && expiresAt > now
      && expiresAt > updatedAt && expiresAt - updatedAt <= 3 * 60 * 60000;

    this.hidden = !valid;
    if (valid) this.expiryTimer = setTimeout(this.refresh, expiresAt - now);
  }
}

customElements.define('bark-recent-viewers', BarkRecentViewers);
